import { render, staticRenderFns } from "./HistoricClassificationFilter.vue?vue&type=template&id=4d981070&scoped=true&"
import script from "./HistoricClassificationFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./HistoricClassificationFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./HistoricClassificationFilter.vue?vue&type=style&index=0&id=4d981070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d981070",
  null
  
)

export default component.exports